import { ParseKeys } from 'i18next'
import { z } from 'zod'

const errorMap: z.ZodErrorMap = (issue, _ctx) => {
  let message: string
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      message = 'validate.required field'
      break
    case z.ZodIssueCode.invalid_union:
      message = `validate.invalid input`
      break
    case z.ZodIssueCode.invalid_date:
      message = `validate.invalid date`
      break
    case z.ZodIssueCode.custom:
      message = (issue.message as ParseKeys) || 'validate.required field'
      break
    default: {
      const defaultResult = z.defaultErrorMap(issue, _ctx)
      message = defaultResult.message as ParseKeys
    }
  }
  return { message }
}

z.setErrorMap(errorMap)
